import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ASSIGNMENT_TEMPLATE = `${TASK_SERVICE}/assignment-templates`;
const API_ASSIGNMENT_TEMPLATE_QUALIFICATION = `${TASK_SERVICE}/assignment-template-qualification-maps`;

export const assignmentTemplates = {
  getAll: async ({ filters, sort } = {}) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
    });
    return apiRequest(options);
  },
  getById: async (id) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_ASSIGNMENT_TEMPLATE,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  createStepTemplateItem: async ({ templateId, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE}/${templateId}/step-templates`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  updateStepTemplateItem: async ({
    assignmentTemplateId,
    stepTemplateId,
    data,
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE}/${assignmentTemplateId}/step-templates/${stepTemplateId}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  deleteStepTemplateItem: async ({
    assignmentTemplateId,
    stepTemplateId,
    data,
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE}/${assignmentTemplateId}/step-templates/${stepTemplateId}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getStepTemplates: async ({
    assignmentTemplateId,
    filters,
    sort,
    top,
    skip,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE}/${assignmentTemplateId}/step-templates`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getStepTemplateById: async ({
    assignmentTemplateId,
    stepTemplateId,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE}/${assignmentTemplateId}/step-templates/${stepTemplateId}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  reorderStepTemplates: async ({
    assignmentTemplateId,
    data,
    modifiedOn,
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE}/${assignmentTemplateId}/reorder-step-templates`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      modifiedOn,
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getAssignmentTemplateQualificationMapsAsync: async ({
    filters,
    sort,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE_QUALIFICATION}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
    });
    return apiRequest(options);
  },
  createAssignmentTemplateQualificationMap: async ({
    data,
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE_QUALIFICATION}`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  deleteAssignmentTemplateQualificationMap: async ({
    id,
    data,
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE_QUALIFICATION}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  patchAssignmentTemplateQualificationMap: async ({
    id,
    data,
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE_QUALIFICATION}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getAssignableResources: async ({ id, filters = {} }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENT_TEMPLATE}/${id}/assignable-resources`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
    });
    return apiRequest(options);
  },
};
